function copyToClipboard(generatedString: string) {
    const copyText = new Promise((resolve) => {
        if (navigator.clipboard !== undefined) {
            navigator.clipboard.writeText(generatedString).then(
                function () {
                    resolve(true);
                },
                function (err) {
                    /* eslint-disable-next-line no-console */
                    console.error("Could not copy text: ", err);
                }
            );
        }
    });
    return copyText;
}

export default copyToClipboard;
